import { TranslatedProperty } from '@/core/models/TranslatedProperty';
import { WithScopes } from '@/core/models/scopes.interface';
import { Salutation } from '../../salutations/salutation.interface';
import { UserInfo } from '../../user-info/user-info.interface';
import { ContactSegmentation } from '../contact-segmentation/contact-segmentation.interface';

export enum ContactRoleKey {
   Contracts = 'contracts',
   Performances = 'performances',
   BvExemption = 'bv-exemption',
   Benefits = 'benefits',
   Reports = 'reports',
   Invoicing = 'invoicing',
   SocialBalance = 'social-balance',
}

export const CONTACT_ROLES_WITH_PERFORMANCES_ACCESS: ReadonlyArray<ContactRoleKey> = [
   ContactRoleKey.Performances,
   ContactRoleKey.Invoicing,
   ContactRoleKey.SocialBalance,
];

export enum ContactActivationStatus {
   UserActive = 'user-active',
   ActivationMailNotSent = 'activation-mail-not-sent',
   ActivationMailSent = 'activation-mail-sent',
   ShowActivation = 'show-activation',
}

export interface Contact extends WithScopes {
   id: number;

   communication_language_id: 1;
   company_id: 1;
   created_at: Date;
   deleted_at?: Date | null;
   email: string;
   first_name: string;
   last_name: string;
   mobile_phone_number: string;
   phone_number: string;
   salutation_id: number;
   updated_at: Date;
   user_id?: number;
   contact_roles?: Array<ContactRole>;

   user?: UserInfo;
   salutation?: Salutation;

   contact_segmentations: Array<ContactSegmentation>;

   contact_activation_status: ContactActivationStatus;
   last_activation_mail_sent_at: string | null;
   activation_mail_not_sent?: boolean;
}

export interface ContactRole {
   id: number;
   key: ContactRoleKey;
   name: TranslatedProperty;
   description: TranslatedProperty;
   created_at?: string;
   updated_at?: string;
}
